import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '../input/input.component';
import { SearchIconComponent, TagCrossIconComponent } from '@kuiper/icons';
import { SearchService } from './search.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { SearchEnum } from '../../../core/common/enums/search.enum';

@Component({
  selector: 'lib-search-field',
  imports: [
    InputComponent,
    SearchIconComponent,
    TagCrossIconComponent,
    ReactiveFormsModule,
    TranslocoPipe,
  ],
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SearchFieldComponent implements OnInit, OnDestroy {
  searchService = inject(SearchService);
  searchInputWidth = input<string>();
  placeholder = input<string>('');
  searchKeywordEmitter = output<string>();
  pressedKeyType = output<string>();

  subscriptions = new Subscription();
  searchForm = new FormGroup({
    search: new FormControl(''),
  });

  ngOnInit(): void {
    this.handleInitialSearch();
    this.syncInputWithSearchService();
  }

  handleInitialSearch() {
    const searchKeyword = this.searchService.currentQuery();
    if (searchKeyword) {
      this.searchForm.get('search')?.setValue(searchKeyword);
      this.searchKeywordEmitter.emit(searchKeyword);
    }
  }

  syncInputWithSearchService() {
    this.subscriptions.add(
      this.searchService.search$.subscribe(searchKeyword => {
        if (!searchKeyword) {
          this.searchForm.get('search')?.setValue('');
        }
      })
    );
  }

  handleTyping(event: string) {
    this.searchService.search(event);
    this.searchKeywordEmitter.emit(event);
  }

  handleClearSearch() {
    this.pressedKeyType.emit(SearchEnum.deleteKeyType);
    this.searchService.clearSearch();
    this.searchKeywordEmitter.emit('');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
